import { Paths } from "../router/paths";
import { getStockAnalysisById } from "../api/services/stock-analysis.api";
import { buildReportDetailPath } from "./stockAnalysisAccess";

const STOCK_ANALYSIS_ACTION = "stock_analysis";

const extractAnalyticsId = (actionUrl?: string): string | null => {
  if (!actionUrl) return null;
  const match = actionUrl.match(
    /\/stock-analyses\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i,
  );
  return match?.[1] ?? null;
};

export const resolveNotificationPath = async (notification: {
  action_url?: string;
  action_type?: string;
}): Promise<string | null> => {
  const actionType = (notification.action_type ?? "").trim().toLowerCase();
  const actionUrl = (notification.action_url ?? "").trim();

  if (actionType === STOCK_ANALYSIS_ACTION) {
    const analyticsId = extractAnalyticsId(actionUrl);
    if (analyticsId) {
      try {
        const response = await getStockAnalysisById(analyticsId);
        const analysis = response.data;
        if (analysis?.report_id) {
          return buildReportDetailPath({
            reportId: analysis.report_id,
            analysisId: analysis.id,
            categoryId: analysis.category_id ?? analysis.category?.id,
            ticket: analysis.ticket,
            company: analysis.company,
          });
        }
      } catch {
        // Fall through to the stock analyses list.
      }
    }
    return Paths.STOCK_ANALYSES;
  }

  if (actionUrl.startsWith("/") && !actionUrl.startsWith("//")) {
    return actionUrl;
  }

  return null;
};
